import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="about-page">
      <Header />
      <div className="about-container">
        <div className="about-hero">
          <img src="/main/a1.png" alt="About Us" />
        </div>
        <div className="about-content">
          <p className="about-label">OUR STORY</p>
          <h1 className="about-title">How we began</h1>
          <div className="about-text-section">
            <p>
              We started Liiskerlane because we wanted something a Liiskerlane
              nicer for our dog. We weren’t inspired by what was in the market.
              Frankly, we felt most pet products were uninspiring, low quality
              and kitschy.
            </p>
            <p>
              We wanted to create a brand that reflects our own aesthetic and
              values. Products that are high quality, thoughtfully designed, and
              ethically produced.
            </p>
            <p>
              Liiskerlane is a community of people who love their dogs and care
              about the products they bring into their homes. We are committed
              to making a positive impact on the world, one dog at a time.
            </p>
          </div>
          <Link to="/shop" className="about-shop-btn" onClick={toTop}>
            SHOP OUR COLLECTION
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default About;
